import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/shared/components/ui/Label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/Select';
import { AnyFieldApi } from '@tanstack/react-form';
import { FieldInfo } from '@/shared/components/form/FieldInfo';
import { IssueStatus } from '@momentum/types';

interface StatusSelectorProps {
  disabled?: boolean;
  field: AnyFieldApi;
}

export const StatusSelector: React.FC<StatusSelectorProps> = ({
  disabled = false,
  field,
}) => {
  const { t } = useTranslation('goals');

  return (
    <div className="space-y-2">
      <Label htmlFor="status">{t('status')}</Label>
      <Select
        value={field.state.value}
        onValueChange={field.handleChange}
        disabled={disabled}
      >
        <SelectTrigger
          id="status"
          onBlur={field.handleBlur}
          className={field.state.meta.errors.length > 0 ? 'border-red-500' : ''}
        >
          <SelectValue placeholder={t('status')} />
        </SelectTrigger>
        <SelectContent>
          {!Object.values(IssueStatus).includes(field.state.value) && (
            <SelectItem value={field.state.value}>
              {field.state.value}
            </SelectItem>
          )}
          <SelectItem value={IssueStatus.TODO}>{t('statusTodo')}</SelectItem>
          <SelectItem value={IssueStatus.IN_PROGRESS}>
            {t('statusInProgress')}
          </SelectItem>
          <SelectItem value={IssueStatus.COMPLETED}>
            {t('statusCompleted')}
          </SelectItem>
        </SelectContent>
      </Select>

      <FieldInfo field={field} />
    </div>
  );
};
